
import utils from "../../../utils/utils.js";
export default {
    async fetchFeedAttachment(context, payload) {
        const feedId = payload.docId;
        const response = await utils.utility.fetch(`api/Editor/GetFeedAttachments?feedId=${feedId}`, "GET", null, null);

        const responseData = response.data;
        for (const index in responseData) {
            responseData[index] = { ...responseData[index], docId: feedId }
        }

        context.commit("setFeedAttachment", responseData);
    }
}